import script from "./Cards.vue?vue&type=script&setup=true&lang=js"
export * from "./Cards.vue?vue&type=script&setup=true&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=4d0da8ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d0da8ee"]])

export default __exports__